export default defineNuxtPlugin(() => {
  document.querySelector("#background")?.classList.add("!opacity-100")
})
